/* eslint-disable */
import axios from "axios";
import { isTaikangStaffMode, isTaikangStaffSession } from "@/utils/sanGaoStaffMode";

function redirectToStaffLogin() {
    // 清理前读取会话版本，确保 token 失效后仍回到同一版本的登录入口。
    const query = new URLSearchParams(window.location.search);
    const taikangMode = query.has("taikang")
        ? isTaikangStaffMode({ taikang: query.get("taikang") }) : isTaikangStaffSession();
    localStorage.removeItem("san_gao_staff_token");
    localStorage.removeItem("san_gao_staff_info");
    const loginPath = window.location.pathname.startsWith("/sanGao/staff/pc/")
        ? "/sanGao/staff/pc/login" : "/sanGao/staff/login";
    const loginUrl = loginPath + (taikangMode ? "?taikang=1" : "");
    if (window.location.pathname + window.location.search !== loginUrl) {
        window.location.replace(loginUrl);
    }
}

class RequestManager {
    constructor() {
        this.axiosInstance = axios.create({
            //baseURL: 'http://localhost:8091',
            baseURL: "https://yisheng.healthmore.net/api",
            timeout: 30 * 1000,
        });
        this._configInterceptors();
        this.defaultErrorHandler = function () {};
    }

    static _instance = null;

    static getInstance() {
        if (null == RequestManager._instance) {
            RequestManager._instance = new RequestManager();
        }
        return RequestManager._instance;
    }

    _configInterceptors() {
        this.axiosInstance.interceptors.request.use(
            (config) => {
                config.headers["Content-Type"] = "application/json; charset=UTF-8";
                const token = localStorage.getItem("san_gao_staff_token");
                if (token && !config.headers["Authorization"]) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        this.axiosInstance.interceptors.response.use(
            (response) => {
                const res = response.data;
                if (res && (res.code === 401 || res.code === "401")) {
                    redirectToStaffLogin();
                    return res;
                }
                return response;
            },
            (error) => {
                if (error.response && error.response.status === 401) redirectToStaffLogin();
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        options = Object.assign({}, options);
        const params = options.params || {};
        const errorHandler = params.errorHandler || this.defaultErrorHandler;
        delete params.errorHandler;
        return this.axiosInstance(options)
            .then((res) => res.data)
            .catch((error) => {
                errorHandler(error);
                return Promise.reject(error);
            });
    }

    setDefaultErrorHandler(defaultErrorHandler) {
        this.defaultErrorHandler = defaultErrorHandler;
    }
}

export default new RequestManager();
